import { useEffect } from 'react'
import getEarningsSummary from '../repository/getEarningsSummary'
import EarningsSummary, { EarningsSummaryDTO } from '../types/EarningsSummary'
import { DEFAULT_EARNINGS } from './useEarningsSummaryMonthly'

type Props = {
  startDate?: Date
  endDate?: Date
  cb: (summaries: EarningsSummaryDTO[], total: EarningsSummary) => void
}

const useFetchEarnings = ({ startDate, endDate, cb }: Props) => {
  const accumulate = (data: EarningsSummaryDTO[]): EarningsSummary => {
    return data.reduce(
      (acc, summary) => {
        acc.grossEarnings += summary.earningsAmount
        acc.netEarnings += summary.netEarningsAmount
        acc.sales += summary.sales
        return acc
      },
      { ...DEFAULT_EARNINGS }
    )
  }

  useEffect(() => {
    const fetchEarningsSummary = async () => {
      const result = await getEarningsSummary({ startDate, endDate })
      const accumulatedResult = accumulate(result)

      cb(result, accumulatedResult)
    }

    fetchEarningsSummary()
  }, [startDate, endDate])
}

export { useFetchEarnings }
